import styles from './AdminSidebar.module.scss';
import AdminSidebarItem from './AdminSidebarItem';
import { adminSidebarNavData } from './AdminSidebarNavData';
import { useLogoutUser } from '@/hooks/useLogoutUser.ts';

const AdminSidebarItemList = () => {
  const { logoutUser, isLoading } = useLogoutUser();
  return (
    <ul className={styles.sidebar__list}>
      {adminSidebarNavData.map((item, index) => {
        return (
          <li
            key={index}
            className={styles.sidebar__list__item}
          >
            <AdminSidebarItem item={item} />
          </li>
        );
      })}
      <li className={styles.sidebar__list__item}>
        <a
          className={`${styles.list__item__link}`}
          onClick={logoutUser}
        >
          <span>{isLoading ? 'Logging out...' : 'Log Out'}</span>
        </a>
      </li>
    </ul>
  );
};

export default AdminSidebarItemList;
